import Axios from 'axios';

//const Base='http://60.205.106.190:8080/honghclient/';
//const Base='http://60.205.145.56:8080/honghclient/';

const Document=document;
const Domin=Document.location.protocol + "//" + Document.location.host;


const Base='/testback/';//远程
const gwBase= 'https://gw.oasisapp.cn';
const JinBase='https://api.oasisapp.cn/';//正式
const PayJin='https://m.oasisapp.cn/pay/payJin.html';//正式


// const Base='http://localhost:8080/honghclient/';//测试本地
// const gwBase= 'https://gwtest.oasisapp.cn';
// const PayJin='https://mtest.oasisapp.cn/pay/payJin.html';//测试
// const JinBase='https://wxtest.oasisapp.cn/';//测试


//const Base='https://buztest56.oasisapp.cn/honghclient/'


const Url={
   Domin:Domin,
   Base:Base,
   PayJin:PayJin,
   JinBase:JinBase,
   Jin:JinBase+'v1/pa',
   YZM:Base+'userAccount/sendCaptchaNew',
   //Login:Base +'userAccount/loginNew',
   Login:gwBase + '/uc/login/mobile',
   ServiceList:Base+'homecareType/getHomecareListByProducttype',
   ServiceDetail:Base+'homecare/detail',
   ServiceOrderList:Base+'bookedService/toAllBookedList',
   ServiceOrderDetail:Base+'bookedService/detail',
   SevviceOrderCancer:Base+'bookedService/doCustomerCancelBooked',
   //doCustomerCancelBooked
   CommentDetil:Base+'comment/tag',
   CommentAdd:Base+'comment/add',
   AwardList:Base+'payaward/getawardlist',
   Award:Base+'payaward/genawardorde',
   PatintList:Base+'bookedService/toConfirmServiceOrder',
   HomeTypeDetail:Base+'bookedService/getHomeTypeDetail',
   NightFeeMsg:Base+'bookedService/toChargeBookdate',
   NightFee:Base+'bookedService/calculateTipPrice',
   Reservation:Base+'bookedService/doAddBookedV1',
}


//{info:'{"status":"'+this.status+'","pagesize":"10","pagenum":'+ page++ +',"accountid":"'+accountid+'"}'}


let JsonGet=function JsonGet(type,Url,info,data){

  return new Promise((resolve,reject) => {
    Axios({
      method:type,
      url:Url+info,
      data:data||'',
    }).then(function (response) {
      // console.log(response,"url接口获取成功");
      resolve(response);
    }).catch(function (error) {
      // console.log(error,"url接口获取失败");
      reject(null);
    });
  })
}

const Api={
  getServiceListOther:JsonGet.bind(this,'POST',Url.ServiceList,'?info={producttype:1,citycode:"110100",count:"4",page:"3"}'),
  getServiceListNuc4:JsonGet.bind(this,'POST',Url.ServiceList,'?info={producttype:1,citycode:"110100",count:"2",page:"1"}'),
  getServiceListDoc4:JsonGet.bind(this,'POST',Url.ServiceList,'?info={producttype:2,citycode:"110100",count:"2",page:"1"}'),
  getServiceListNuc:JsonGet.bind(this,'POST',Url.ServiceList,'?info={producttype:1,citycode:"110100",count:"999",page:"1"}'),
  getServiceListDoc:JsonGet.bind(this,'POST',Url.ServiceList,'?info={producttype:2,citycode:"110100",count:"999",page:"1"}'),
  postSevviceOrderCancer:JsonGet.bind(this,'POST',Url.SevviceOrderCancer),
  getServiceDetail:JsonGet.bind(this,'POST',Url.ServiceDetail),
  getServiceOrderList:JsonGet.bind(this,'POST',Url.ServiceOrderList),
  getServiceOrderDetail:JsonGet.bind(this,'POST',Url.ServiceOrderDetail),
  getComment:JsonGet.bind(this,'POST',Url.CommentDetil),
  postCommentAdd:JsonGet.bind(this,'POST',Url.CommentAdd),//需要APP版本号等参数 第三方无法调用
  getAwardList:JsonGet.bind(this,'POST',Url.AwardList),
  postAward:JsonGet.bind(this,'POST',Url.Award),
  getPatintList:JsonGet.bind(this,'POST',Url.PatintList),
  getNightFeeMsg:JsonGet.bind(this,'POST',Url.NightFeeMsg),
  //getNightFee:JsonGet.bind(this,'POST',Url.NightFee),
  getHomeTypeDetail:JsonGet.bind(this,'GET',Url.HomeTypeDetail),
  postReservation:JsonGet.bind(this,'POST',Url.Reservation)
}

export {Api,Url}



// WEBPACK FOOTER //
// ./src/assets/js/api.js